import { PolymorphicComponentPropWithRef } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type CardComponentProps = {
    color?: string;
    body?: boolean;
    inverse?: boolean;
    outline?: boolean;
};

export type CardProps<T extends React.ElementType> =
    PolymorphicComponentPropWithRef<T, CardComponentProps, "div">;

const Card = <T extends React.ElementType = "div">({
    ref,
    className,
    color,
    body,
    inverse,
    outline,
    tag,
    ...attributes
}: CardProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const classes = cn(
        className,
        "card",
        inverse ? "text-white" : false,
        body ? "card-body" : false,
        color ? `${outline ? "border" : "bg"}-${color}` : false
    );

    return (
        <Tag
            {...attributes}
            className={classes}
            ref={ref}
        />
    );
};

export { Card };
